import { AllPaymentTypes, OrderPaymentType } from "./orders";

export enum CouponKindType {
  Order = "order",
  TopUp = "topUp",
}

export enum CouponType {
  GiftVoucher = "giftVoucher",
  DiscountCode = "discountCode",
  DiscountCodeFiat = "discountCodeFiat",
}

export enum CouponTypeLabel {
  giftVoucher = "Gift Voucher",
  discountCode = "Discount Code",
}

export enum DiscountType {
  Percentage = "percentage",
  PercentageDiscount = "percentageDiscount",
  FiatCents = "fiatCents",
  FmcCents = "fmcCents",
}

export enum DiscountTypeLabel {
  percentage = "Percentage",
  percentageDiscount = "Percentage (Discount)",
  fiatCents = "KWD",
  fmcCents = "FM Coins",
}

export enum TopUpDiscountTypeLabel {
  percentage = "Percentage (Bonus)",
  percentageDiscount = "Percentage (Discount)",
  fmcCents = "FM Coins (Bonus)",
}

export enum CouponPaymentLabel {
  all = "All",
  fiatCents = "KWD",
  fmcCents = "FM Coins",
}

export type CouponAllowedUser = {
  id: string;
  email: string | null;
  phoneNumber: string | null;
  firstName?: string;
  lastName?: string;
  fullName?: string;
};

export type Coupon = {
  id: string;
  createdAt: string;
  updatedAt: string;
  discountOff: number;
  discountType: DiscountType;
  startDate: string;
  expiryDate: string;
  numberOfUses: number;
  couponCode: string;
  isActive: boolean;
  allowMultipleUsage: boolean;
  allowedUsers: CouponAllowedUser[];
  minimumOrderFiatCentsPrice: number;
  minimumOrderFmcCentsPrice: number;
  orderPaymentType: OrderPaymentType | AllPaymentTypes;
  couponType: CouponType;
  type: CouponKindType;
  couponUsed?: string;
  orderSid?: string;
  exchangeRate?: number;
  discountFiatCents?: number;
  numberOfUniqueUses?: number;
  couponUsageCount: number;
  disableBonusCoins?: boolean;
  maxTopUpLimit?: number;
};

export type GetCouponsResponseDto = {
  items: Coupon[];
  totalCount: number;
};

export type CreateCouponRequestData = {
  discountOff: number;
  discountType: DiscountType | null;
  couponType: CouponType;
  expiryDate: string;
  startDate: string;
  numberOfUses: number;
  allowedUsers: string[];
  allowMultipleUsage: boolean;
  isActive: boolean;
  minimumOrderFiatCentsPrice: number;
  minimumOrderFmcCentsPrice: number;
  orderPaymentType: OrderPaymentType | AllPaymentTypes | null;
  type: CouponKindType;
  numberOfCouponsToGenerate?: number;
  name?: string;
  exchangeRate?: number;
  discountFiatCents?: number;
  numberOfUniqueUses?: number;
  disableBonusCoins?: boolean;
  maxTopUpLimit?: number | null;
};

export type CreateCouponRequestDto = CreateCouponRequestData;

export type UpdateCouponRequestDto = {
  id: string;
  data: CreateCouponRequestData;
};

export type CouponUsedByUser = {
  id: string;
  firstName: string;
  email: string;
  phoneNumber: string;
  createdAt: string;
};

export type GetCouponsUsedByUsersListResponseDto = {
  items: CouponUsedByUser[];
  totalCount: number;
};

export type UploadCsvRequest = {
  id: string;
  formData: FormData;
};
